export const environment = {
  production: false,
  api: 'https://qa-api.suburbansupplyinc.com',
  cognitoClientId: '5hp9far0per9jk6rftir61e1km',
  authority: 'https://cognito-idp.us-east-1.amazonaws.com/us-east-1_cydtiemd1',
  cognitoDomain: 'https://us-east-1cydtiemd1.auth.us-east-1.amazoncognito.com',
  appTitle: 'QA Rep Suburban',
  rum: {
    enabled: true,
    appName: 'rep-flow',
    environmentName: 'qa',
    applicationId: '9436f496-83fd-4d6d-8e6f-391be64a77b4',
    applicationVersion: '1.0.0',
    applicationRegion: 'us-east-2',
    identityPoolId: 'us-east-2:92694b3e-acfd-466d-aee8-3c8bad3e65ff',
    guestRoleArn: 'arn:aws:iam::412381779150:role/suburban-rum-unauth-role',
    sessionSampleRate: 1,
    allowCookies: true,
    enableXRay: false,
  },
};
